import React from 'react'
import { Box, Paper, Stack, Typography } from '@mui/material'
import { makeStyles } from 'tss-react/mui'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { getLocalizedNumber } from 'src/Libs/languages/functions/default'
import { AZElectricity } from '@e3dc-react/icons'
import { useStatCardStyles } from './stat-card.styles'

const useStyles = makeStyles()(theme => ({
  iconBackground: {
    backgroundColor: theme.palette.chart.totalDischargedEnergyCardBackground,
  },
  icon: {
    color: theme.palette.error.main,
  },
}))

interface Props {
  dischargedEnergyKwh: number
}

/**
 * Component for displaying energy values for discharging as statistic card inside e-mobility charging sessions.
 * @param dischargedEnergyKwh number - represent discharged energy in kWh units
 * @return JSX Element
 */
const DischargedEnergyCard: React.VFC<Props> = ({ dischargedEnergyKwh }) => {
  const { t } = useCustomTranslation()
  const { classes, cx } = useStyles()
  const { classes: statCardClasses } = useStatCardStyles()

  return (
    <Paper className={statCardClasses.card}>
      <Stack direction="row" spacing={2}>
        <Box className={cx(statCardClasses.circularContainer, classes.iconBackground)}>
          <AZElectricity fontSize="large" className={classes.icon} />
        </Box>

        <Stack justifyContent="space-between">
          <Box>
            <Typography variant="subtitle2">{t('emobility.chargingSession.total-energy-discharged-kwh')}</Typography>
          </Box>
          <Box>
            <Typography variant="h2">{t('common.format.kwh', { value: getLocalizedNumber(dischargedEnergyKwh, 2) })}</Typography>
          </Box>
        </Stack>
      </Stack>
    </Paper>
  )
}

export default DischargedEnergyCard
